module.exports = __webpack_public_path__ + "img/67.f97d523a.png";